// extracted by mini-css-extract-plugin
export default {"requirementsTitle":"UploadButton_requirementsTitle__RJQuK","requirementsList":"UploadButton_requirementsList__zmDbF"};